var map = {
	"./unavailable_billing.svg": "e0a0",
	"./unavailable_crm.svg": "7e78",
	"./unavailable_distribution.svg": "77f8",
	"./unavailable_printing.svg": "7947",
	"./unavailable_scanning.svg": "4cd5",
	"./unavailable_shipping.svg": "86d8",
	"./unavailable_statistics.svg": "9353",
	"./unavailable_stocks.svg": "a317"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1197";